import React from "react";
const Kepegawaian = React.lazy(() => import('./kepegawaian'));
const Produksi = React.lazy(() => import('./produksi'));

export const dashboardPageConfig = [
    {
        path: '/dashboard/kepegawaian',
        element:<Kepegawaian/>
    },
    {
        path: '/dashboard/produksi',
        element:<Produksi/>
    }
];